import type { SportProfile } from '@/types'

export const lacrosseBox: SportProfile = {
  id: 'lacrosse-box-indoor',
  sport: 'lacrosse',
  gender: 'mens',
  environment: 'indoor',
  label: 'Box Lacrosse (Indoor)',
  emoji: '🥍',
  playersOnField: 6,
  contactLevel: 'full',
  hasShotClock: true,
  shotClockSeconds: 30,
  periods: { label: 'Period', count: 3, durationMinutes: 20 },
  positions: [
    { key: 'goalie', label: 'Goalie', shortLabel: 'G', maxOnField: 1 },
    { key: 'transition', label: 'Transition', shortLabel: 'T', maxOnField: 2 },
    { key: 'forward', label: 'Forward', shortLabel: 'F', maxOnField: 3 },
  ],
  stats: [
    { key: 'goal', label: 'Goal', shortLabel: 'G' },
    { key: 'assist', label: 'Assist', shortLabel: 'A' },
    { key: 'shot', label: 'Shot', shortLabel: 'SH' },
    { key: 'shot_on_goal', label: 'Shot on Goal', shortLabel: 'SOG' },
    { key: 'save', label: 'Save', shortLabel: 'SV' },
    { key: 'penalty_minor', label: 'Minor Penalty', shortLabel: 'MIN', statType: 'card' },
    { key: 'penalty_major', label: 'Major Penalty', shortLabel: 'MAJ', statType: 'card' },
    { key: 'violation', label: 'Violation', shortLabel: 'VIO', statType: 'violation' },
    { key: 'opp_shot', label: 'Opp Shot', shortLabel: 'OPP', statType: 'opp-shot' },
    { key: 'power_play_goal', label: 'Power Play Goal', shortLabel: 'PPG' },
    { key: 'shorthanded_goal', label: 'Shorthanded Goal', shortLabel: 'SHG' },
    { key: 'loose_ball', label: 'Loose Ball Pickup', shortLabel: 'LB' },
    { key: 'turnover', label: 'Turnover', shortLabel: 'TOV' },
    { key: 'caused_turnover', label: 'Caused Turnover', shortLabel: 'CT' },
  ],
}
